import { render, staticRenderFns } from "./QueryConfirmDialog.vue?vue&type=template&id=5d7e8a50"
import script from "./QueryConfirmDialog.vue?vue&type=script&lang=ts"
export * from "./QueryConfirmDialog.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports